import { maxLength, minLength, required, email } from '../../utils/validation';
import { normalizeUserPermissions } from '../../utils/inputs/index';

export const UserPermissionsNormalize = {
  permissions: value => normalizeUserPermissions(value)
};

export const UserValidations = {
  name: [required('models.user.name'), maxLength(24, 'models.user.name')],
  email: [
    required('models.user.email'),
    email('models.user.email'),
    maxLength(54, 'models.user.email')
  ],
  userPermissions: [required('models.user.userPermissions')],
  recaptcha: [required('models.user.recaptcha')],
  password:[
    required('models.user.password'),
    minLength(8,'models.user.password')
  ]
};

class Serializer {
  normalize = data => {
    return {
      data
    };
  };
  serialize = user => {
    return {
      sites: user.sitePermissions,
      email: user.email,
      permissions: user.userPermissions
    };
  };

  serializeEdit = user => {
    return {
      siteId: user.sitePermissions[0],
      email: user.email,
      Admin: user.userPermissions.Admin,
      Status: user.userPermissions.Status,
      AddTags: user.userPermissions.AddTags,
      EditDeleteGroupsCategories:
        user.userPermissions.EditDeleteGroupsCategories,
      EditDeleteTags: user.userPermissions.EditDeleteTags
    };
  };
}

export const UserSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/user/index.js